// extracted by mini-css-extract-plugin
export default {"productList":"ProductList_productList__R8Z3+"};